import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "../lib/api";
import Layout from "../components/Layout";

export default function Search() {
  const [sp] = useSearchParams();
  const q = sp.get("q") || "";
  const [data, setData] = useState({ threads: [], users: [], groups: [] });

  useEffect(() => {
    if (q.length < 2) return;
    api.get(`/search?q=${encodeURIComponent(q)}`).then((r) => setData(r.data));
  }, [q]);

  return (
    <Layout>
      <h1 className="font-display text-3xl text-white mb-1">Søk</h1>
      <p className="text-zinc-400 text-sm mb-6">Resultater for «{q}»</p>

      <section className="mb-6">
        <h2 className="font-display text-lg text-white mb-2">Tråder</h2>
        <div className="rounded-lg border border-white/10 bg-[#0a0a0a]">
          {data.threads.length === 0 ? (
            <div className="px-5 py-4 text-zinc-500 text-sm">Ingen treff</div>
          ) : (
            <ul className="divide-y divide-white/5">
              {data.threads.map((t) => (
                <li key={t.id}>
                  <Link to={`/thread/${t.id}`} className="block px-5 py-3 text-zinc-200 hover:bg-white/5">{t.title}</Link>
                </li>
              ))}
            </ul>
          )}
        </div>
      </section>

      <section className="mb-6">
        <h2 className="font-display text-lg text-white mb-2">Brukere</h2>
        <div className="rounded-lg border border-white/10 bg-[#0a0a0a]">
          {data.users.length === 0 ? (
            <div className="px-5 py-4 text-zinc-500 text-sm">Ingen treff</div>
          ) : (
            <ul className="divide-y divide-white/5">
              {data.users.map((u) => (
                <li key={u.id}>
                  <Link to={`/profile/${u.username}`} className="block px-5 py-3 text-zinc-200 hover:bg-white/5">{u.username}</Link>
                </li>
              ))}
            </ul>
          )}
        </div>
      </section>

      <section>
        <h2 className="font-display text-lg text-white mb-2">Grupper</h2>
        <div className="rounded-lg border border-white/10 bg-[#0a0a0a]">
          {data.groups.length === 0 ? (
            <div className="px-5 py-4 text-zinc-500 text-sm">Ingen treff</div>
          ) : (
            <ul className="divide-y divide-white/5">
              {data.groups.map((g) => (
                <li key={g.id}>
                  <Link to={`/groups/${g.id}`} className="block px-5 py-3 text-zinc-200 hover:bg-white/5">{g.name}</Link>
                </li>
              ))}
            </ul>
          )}
        </div>
      </section>
    </Layout>
  );
}
